import React from 'react';

import * as apiUtil from "../../../util/apiUtil";
import CryptoJS from 'crypto-js';

import loginPageCss from "../css/loginPage.module.css";

class SyncLoginProcess extends React.Component {
    constructor(props) {
        super(props);

        this.ajaxCheckValidUserInfo = this.ajaxCheckValidUserInfo.bind(this);
        this.onChangeHostId = this.onChangeHostId.bind(this);
    }

    ajaxCheckValidUserInfo() {
        const { registerInfo, checkInfo } = this.props;

        const hostId = registerInfo.hostId;

        /* 사용자가 ID를 입력하지 않고 조회 버튼을 눌렀을 경우 */
        if (hostId === '') {
            alert(`${registerInfo.hostType} ID를 입력해주세요 `);
            return;
        }

        apiUtil.asyncRequest({
            url: "/api/bizchat/user/cafe24/mallId/" + hostId + "/valid",
            data: { ...registerInfo, ...checkInfo },
            method: apiUtil.requestMethod.POST,
            success: (result) => {
                if (result) {
                    const state = {
                        hostType: 'C',
                        hostId: hostId,
                    }
                    let encryptedState = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(state), process.env.REACT_APP_AES_ENCRYPT_KEY).toString());

                    let url = `https://${hostId}.cafe24api.com/api/v2/oauth/authorize`;
                    url += `?response_type=code`;
                    url += `&client_id=${process.env.REACT_APP_CAFE24_CLIENT_ID}`;
                    url += `&redirect_uri=${process.env.REACT_APP_CAFE24_REDIRECT_URI}`;
                    url += `&scope=${process.env.REACT_APP_CAFE24_SCOPE}`;
                    url += `&state=${encryptedState}`;
                    window.location.href = url;
                } else {
                    alert(`${hostId}와 일치하는 ${registerInfo.hostType} 정보를 찾을 수 없습니다.`);
                }
            }
        })
    }

    onChangeHostId(e) {
        const value = e.target.value;
        const { setValue } = this.props;
        setValue("hostId", value);
    }

    render() {
        const { registerInfo } = this.props;
        const { ajaxCheckValidUserInfo, onChangeHostId } = this;

        return (
            <>
                { registerInfo.hostType } 업체의 정보를 입력해서 업체 정보를 채워 넣을 수 있습니다.
                <div className='row g-3 align-items-center pt-3'>
                    <div className='col-sm-3'>
                        <label htmlFor="hostId">{ registerInfo.hostType } ID 입력</label>
                    </div>
                    <div className='col-sm-9 d-flex'>
                        <input id="hostId" className={`form-control me-2`} defaultValue={registerInfo.hostId} type="text" onChange={onChangeHostId}/>
                        <button className={`${loginPageCss["btn"]} btn btn-outline-primary`} onClick={ajaxCheckValidUserInfo}>조회</button>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-sm-3'></div>
                    <div className='col-sm-9'>
                        <ul className={`${loginPageCss["list-unstyled"]} ${loginPageCss["text-muted"]} list-unstyled text-muted mb-2`}>
                            <li>
                                <small>* 카페 24 ID 조회를 통해 간편하게 정보를 불러올 수 있습니다.</small>
                            </li>
                            <li>
                                <small>* 해당 기능은 카페 24를 통해 쇼핑몰을 운영하는 쇼핑몰에 한해서만 사용이 가능 합니다. </small>
                            </li>
                            <li>
                                <small>* 타 호스팅사를 시용하는 사장님들께서는 하위정보를 입력해주시기 바랍니다</small>
                            </li>
                        </ul>
                    </div>
                </div>

            </>
        )
    }
}

export default SyncLoginProcess;
